import {_, React, observer, observable, computed, IDisposer, action, useLocalStore, useEffect, useLayoutEffect, classNames, useAsObservableSource} from '@api'
import {AssortmentCardStore, AssortmentSwatchStore, useAssortmentCardStore, useVipLocalStore, VipLocalStore} from '@modules'
import {AssortmentSwatch} from '@modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/Assortments/AssortmentCard/Swatches/AssortmentSwatch'
import {StoresInstance, ui} from '@stores'
import {toJS} from 'mobx'
import * as css from './AssortmentSwatches.css'

/// region Store

export class AssortmentSwatchesStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props: Omit<MyProps, 'className'> & { card: AssortmentCardStore }) {
    super(stores)
    if (!props.card.componentStores.swatches) {
      props.card.componentStores.swatches = this
    }
  }

  registerEffects = () => {
    const _toDispose: Array<IDisposer> = []

    return () => {
      _toDispose.forEach(d => d())
    }
  }

  get data() {
    return this.props.card.bucket.swatches
  }

  get card() { return this.props.card}

  get config() {
    return this.card.assortment.swatches
  }

  @observable.shallow storesById: {[id: string]: AssortmentSwatchStore} = {}

  @computed get swatches() : Array<{field: string, item: any}> {
    const {data, config, es, stores, catalog, catalog: {findFieldInTree}} = this
    if (!data || _.isEmpty(config)) return []

    const swatchData = _.flatMap(
      config.map(({field,filter}) => {
      const agg = data[field]
      let r = agg.buckets.map(b => {
        return ({field, item: _.first(es.unwrapHitsResult(b.item).items)})
      })

      return r
    }))

    let flattened = _.flatMap(swatchData.map(({field, item}) => {
      const esField = findFieldInTree(field, true)

      const v = es.readField(item, esField ? esField.field : field)?.val
      if (_.isArray(v)) {
        return v.map(item => ({field, item}))
      } else {
        return {field, item: v}
      }
    }))

    // if (filter) {
    //   try {
    //     r = filter(r, this.stores)
    //   } catch (err) {
    //     catalog.onError(err)
    //   }
    // }

    const uniq = _.uniqBy(flattened, ({item}) => catalog.idFor(item) ?? item)

    const byField = _.groupBy(uniq, f => f.field) as Record<string, any>

    config.forEach(({filter, field}) => {
      if (filter) {
        byField[field] = filter(byField[field] ?? [], stores)
      }
    })

    const r = _.flatMap(_.values(byField))

    // console.log([flattened, uniq, byField, r])
    return r
  }

  @computed get swatchesToRender() {
    const {swatches, catalog: {settings: {assortment: {layout: {swatchesPerColumn, columns}}}}} = this,
      maxToRender = swatchesPerColumn * columns

    let r = _.take(swatches, maxToRender)

    return maxToRender <= swatches.length
           ? r
           : [...r, ...new Array(maxToRender - swatches.length)]
  }
}

export const AssortmentSwatchesStoreContext = React.createContext<AssortmentSwatchesStore>(null)
export const useAssortmentSwatchesStore = () => React.useContext(AssortmentSwatchesStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
}

export const AssortmentSwatches = observer<MyProps, HTMLDivElement>(function AssortmentSwatches({className, ...props}, ref) {
  const card = useAssortmentCardStore(),
    obsProps = useAsObservableSource({props, card}),
    store = useVipLocalStore((stores) => new AssortmentSwatchesStore(stores, obsProps)),
    {swatches, catalog: {settings: {assortment: {layout: {swatchesPerColumn}}}}, swatchesToRender} = store

  useEffect(() => store.registerEffects(), [])

  // console.log(toJS(swatches))
  return (
    <AssortmentSwatchesStoreContext.Provider value={store}>
      <div className={classNames(css.root, className)} ref={ref}>
        {_.chunk(swatchesToRender, swatchesPerColumn).map(
          (swatches, i) => <div className={css.swatchColumn} key={i}>
            {swatches.map((swatch, j) => <AssortmentSwatch className={css.swatch} key={j} index={j} swatch={swatch}/>)}
          </div>)}
      </div>
    </AssortmentSwatchesStoreContext.Provider>)
}, {forwardRef: true})

/// endregion




// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/Assortments/AssortmentCard/Swatches/AssortmentSwatches.tsx